import type { SyncSourceInfo } from "../../lib/googleApi";

type Props = {
  label: string;
  sources: SyncSourceInfo[];
  fallbackName: string;
  onRemove: (source: SyncSourceInfo) => void;
};

export function SyncSourceList({ label, sources, fallbackName, onRemove }: Props) {
  if (sources.length === 0) return null;

  return (
    <div className="form-group">
      <label className="label">{label}</label>
      <div className="sync-source-list">
        {sources.map((source) => (
          <div key={source.id} className="sync-source-item">
            <div className="sync-source-info">
              <span
                className="calendar-color-dot"
                style={{ background: source.calendarColor ?? "#78716C" }}
              />
              <span>{source.calendarSummary ?? fallbackName}</span>
            </div>
            <button
              className="btn btn-danger btn-sm"
              onClick={() => onRemove(source)}
            >
              Remove
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
